import React from 'react';
import CountUp from 'react-countup';

const Status = () => {
  return (
    <section className='py-10 md:py-20 px-4 bg-gray_light'>
      <div className='max-w-7xl w-full mx-auto grid grid-cols-1 md:grid-cols-3 gap-y-10 text-center'>
        <div className='px-4'>
          <h2 className='text-3xl md:text-5xl text-headings font-bold mb-2 md:mb-4'>
            <CountUp end={9} duration={2} /> out of 10
          </h2>
          <p className='text-base md:text-lg text-light_black md:max-w-[330px] mx-auto'>
            Customers would recommend us to their friends.
          </p>
        </div>

        <div className='md:border-x border-x-gray-300 px-4'>
          <h2 className='text-3xl md:text-5xl text-headings font-bold mb-4'>
            <CountUp end={3.5} decimals={1} duration={2} />x
          </h2>
          <p className='text-base md:text-lg text-light_black md:max-w-[330px] mx-auto'>
            More productivity gained by using Tuber versus self-pickups.
          </p>
        </div>

        <div className='px-4'>
          <h2 className='text-3xl md:text-5xl text-headings font-bold mb-4'>
            <CountUp end={77} duration={2} />%
          </h2>
          <p className='text-base md:text-lg text-light_black md:max-w-[330px] mx-auto'>
            Time saved compared to finding parking, locating materials, and returning to
            work.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Status;
